export const formatCompactNumber = (number: number, setting: any) => {
    return Intl.NumberFormat('en', setting).format(number);
}

export const convertNumber = (number: number, notation: boolean = false) => {
    return formatCompactNumber(number, notation ? { notation: 'compact' } : {})
}